import { render, staticRenderFns } from "./BreadcrumbTrail.vue?vue&type=template&id=5de0202a&"
import script from "./BreadcrumbTrail.vue?vue&type=script&lang=js&"
export * from "./BreadcrumbTrail.vue?vue&type=script&lang=js&"
import style0 from "./BreadcrumbTrail.vue?vue&type=style&index=0&id=5de0202a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports